import { TrendReq, TrendDef } from "../../type/trend";

import { formatDate } from "../../../../lib/helper";

export class TrendAdapter {
  static toInputDTO(req: TrendReq): any {
    const selectedNode = req.node_attrs.find((attr) => attr.value);
    return {
      node: selectedNode ? selectedNode.key : null,
      avg_smooth_window: 3,
      avg_smooth_method: "rolling",
    };
  }

  static toOutputDTO(res: any): TrendDef {
    if (!res?.trends) return [];

    // 系列キーは value_label を優先 (新DB: 20代/男性 等)。無い (legacy / avg) ときは生 label。
    const pick = (label: any, raw: any): any =>
      label != null && label !== "" ? String(label) : raw;

    return res.trends.map((series: any, index: number) => {
      const seriesMaps = series.values.map((seriesObj: any) => {
        const map: { [date: string]: number } = {};
        if (seriesObj.dates && seriesObj.series) {
          for (let i = 0; i < seriesObj.dates.length; i++) {
            map[seriesObj.dates[i]] = seriesObj.series[i];
          }
        }
        return { label: pick(seriesObj.value_label, seriesObj.label), map };
      });

      const dateSet = new Set<string>();
      series.values.forEach((seriesObj: any) => {
        if (seriesObj.dates) {
          seriesObj.dates.forEach((d: string) => dateSet.add(d));
        }
      });
      const unionDates = Array.from(dateSet).sort();

      const trend = unionDates.map((date) => {
        const obj: any = { datetime: formatDate(date, "YY/MM") };

        seriesMaps.forEach((series: any) => {
          const value = series.map.hasOwnProperty(date)
            ? series.map[date]
            : null;
          obj[series.label] = value;
        });
        return obj;
      });

      return {
        id: index,
        key: series.key,
        values: trend,
      };
    });
  }
}
